import { useEffect, useState } from "react";
import FormField from "./FormField";
import Text from "./Text";
import Container from "./Container";
import { InputText } from "primereact/inputtext";
import Icon from "./Icon";
import { ProgressSpinner } from "primereact/progressspinner";
import useAuthHttp from "../hooks/useAuthHttp";
import { useQuery } from "@tanstack/react-query";

export interface ICurrency {
    id: string;
    code: string;
    name: string;
    symbol: string;
    country_code: string;
    country_name: string;
    type: string;
    chk_code: string;
    exclude_ptax_date: string | null;
    date_add: string | null;
}

export interface ICurrencySelected {
    id: string;
    name: string;
    symbol: string;
}

interface ICurrencyList {
    currency_list: ICurrency[];
}

export interface ICurrencySearchSelectorProps {
    selected: ICurrencySelected|undefined;
    select: (currency: ICurrencySelected|undefined) => void;
    hasError?: boolean;
    error?: string;
}

const CurrencySearchSelector = (props: ICurrencySearchSelectorProps) => {
    const [searchQueryDebounce, setSearchQueryDebounce] = useState<string>("");
    const [searchQuery, setSearchQuery] = useState<string>("");

    const authHttp = useAuthHttp();
    const currencyQuery = useQuery({
        queryKey: ["currency", searchQueryDebounce],
        queryFn: async () => {
            if (!searchQueryDebounce) {
                return { currency_list: [] };
            }
            
            return await authHttp.doGet<ICurrencyList>("/currency?search=" + searchQueryDebounce);
        }
    });
    useEffect(() => {
        const timeout = setTimeout(async () => {
            setSearchQueryDebounce(searchQuery);
        }, 1500);

        return () => clearTimeout(timeout);
    }, [searchQuery]);

    return (
        <FormField
            id="currencySearchSelector"
            label="Moeda"
            hasError={props.hasError}
            error={props.error}
        >
            <Container relative>
                <InputText 
                    value={props.selected?.name ?? searchQuery}
                    className="w-full pr-5"
                    placeholder="Procure pelo código"
                    invalid={props.hasError}
                    onChange={(e) => {
                        setSearchQuery(e.target.value);
                    }}
                />
                
                {
                    props.selected && <Icon 
                        name="pi-times"
                        className="absolute right-0 mr-1 p-2 text-red-500 bg-white"
                        onClick={() => {
                            props.select(undefined);
                            setSearchQuery("");
                        }}
                        style={{ transform: "translateY(-50%)", top: "50%" }}
                    />
                }
            </Container>
            {
                currencyQuery.isPending && (
                    <Container center flexColumn className="my-progress-spinner p-4" gap={2}>
                        <ProgressSpinner className="w-2rem h-auto" />
                        <Text>Carregando...</Text>
                    </Container>       
                )
            }

            {
                !!currencyQuery.data?.currency_list.length && !props.selected && !currencyQuery.isPending && searchQuery && <div className="bg-white w-full">
                    <ul className="list-none p-0 flex gap-2 flex-column">
                        {
                            currencyQuery.data.currency_list.map(currency => {
                                return (
                                    <li key={currency.id}>
                                        <a 
                                            className="cursor-pointer" 
                                            onClick={() => {
                                                props.select(currency);
                                                setSearchQuery("");
                                            }}
                                        >
                                            {currency.name}
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            }
        </FormField>
    );
}

export default CurrencySearchSelector;